import React from 'react';
import { motion } from 'framer-motion';
import { Box } from '@mui/material';
import { images } from '../assets/images';

const LogoStrip: React.FC = () => {
  const logos = [...Array(8)]; // Ensuring enough width for most screens
  const getLogoSrc = (i: number) => (i % 2 === 0 ? images.logo : images.logo2);

  return (
    <Box
      sx={{
        backgroundColor: 'black',
        py: 4,
        height: 100,
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <Box
        component={motion.div}
        animate={{ x: '-50%' }}
        transition={{
          repeat: Infinity,
          ease: 'linear',
          duration: 30, // Adjust speed here
        }}
        sx={{
          display: 'flex',
          gap: 8, // Increased gap for better visual separation
          width: 'max-content',
        }}
      >
        {/* First Set */}
        {logos.map((_, index) => (
          <Box
            key={`set1-${index}`}
            component="img"
            src={getLogoSrc(index)}
            alt={`Bluecat Logo ${index + 1}`}
            sx={{
              height: 48,
              width: 'auto',
              opacity: 0.9,
              filter: 'grayscale(100%)',
              '&:hover': { filter: 'none', opacity: 1 },
              transition: 'all 0.3s',
            }}
          />
        ))}
        {/* Duplicate Set for Loop */}
        {logos.map((_, index) => (
          <Box
            key={`set2-${index}`}
            component="img"
            src={getLogoSrc(index)}
            alt={`Bluecat Logo ${index + 1}`}
            sx={{
              height: 48,
              width: 'auto',
              opacity: 0.9,
              filter: 'grayscale(100%)',
              '&:hover': { filter: 'none', opacity: 1 },
              transition: 'all 0.3s',
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default LogoStrip;
